<template>
<div class="info-widget-cell">
  <div v-if="title.length > 0" class="info-widget-cell__title">{{this.$t(title)}}</div>
  <div
    ref="data"
    class="info-widget-cell__data"
    :class="{ 'info-widget-cell__data--fit': fitToWidth }"
  >{{value}}</div>
</div>
</template>

<script>
const MIN_FIT_FONT_SIZE_PX = 12;

export default {
  name: 'InformationWidgetCell',
  props: {
    title: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    fitToWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resizeObserver: null,
      observedWidth: 0,
    };
  },
  watch: {
    value() {
      if (this.fitToWidth) {
        this.$nextTick(this.fitValue);
      }
    },
  },
  mounted() {
    if (!this.fitToWidth) return;
    this.fitValue();
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.$el);
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  methods: {
    onResize([entry]) {
      // Only refit on real width changes, so our own font change can't trigger a resize loop
      const { width } = entry.contentRect;
      if (width === this.observedWidth) return;
      this.observedWidth = width;
      this.fitValue();
    },
    fitValue() {
      const element = this.$refs.data;
      if (!element) return;
      element.style.fontSize = '';
      const { clientWidth, scrollWidth } = element;
      if (!clientWidth || scrollWidth <= clientWidth) return;
      const baseFontSize = parseFloat(window.getComputedStyle(element).fontSize);
      const fittedFontSize = Math.max(
        MIN_FIT_FONT_SIZE_PX,
        Math.floor(baseFontSize * (clientWidth / scrollWidth) * 10) / 10,
      );
      element.style.fontSize = `${fittedFontSize}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.info-widget-cell{
  display: flex;
  flex-direction: column;
  color: var(--text-primary);
  min-width: rem(125);
  margin-right: rem(20);
  &__title{
    font-family: $font-family-regular;
    font-size: rem(12);
    letter-spacing: 0;
    line-height: rem(15);
    margin-bottom: rem(5);
  }
  &__data{
    font-family: $font-family-semibold;
    font-size: rem(24);
    font-weight: 600;
    letter-spacing: 0;
    line-height: rem(29);
    margin-top: rem(-5);
    &--fit{
      white-space: nowrap;
    }
  }
}

</style>
